"use client";
//#region packages/@mantine/hooks/src/utils/random-id/random-id.ts
function randomId(prefix = "mantine-") {
	return `${prefix}${Math.random().toString(36).slice(2, 11)}`;
}
//#endregion
export { randomId };

//# sourceMappingURL=random-id.mjs.map